import WarranteeDetailDialogComponent from "./warranteeDetailDialog.container";

export default WarranteeDetailDialogComponent;